// Keep meta descriptions within Google's ~160-char snippet: whole sentences first, else cut at a word.
export function metaDesc(text, max = 158) {
  const t = String(text || '').replace(/\s+/g, ' ').trim();
  if (t.length <= max) return t;
  let out = '';
  for (const s of t.match(/[^.!?]+[.!?]+(\s|$)/g) || []) {
    if ((out + s).trim().length > max) break;
    out += s;
  }
  if (out.trim().length >= 90) return out.trim();
  const cut = t.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(' ')).replace(/[,;:\s—–-]+$/, '')}…`;
}
